import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import bcrypt from 'bcryptjs';
import DatabaseManager from '../utils/DatabaseManager';

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const { email, password } = values;
      
      // Find user by email
      const user = await DatabaseManager.Ejecutivo.findOne({
        where: { email, activo: true },
        include: [{ model: DatabaseManager.Ciudad }]
      });

      if (!user) {
        message.error('Usuario no encontrado o inactivo');
        return;
      }

      // Verify password
      const isValidPassword = await bcrypt.compare(password, user.password);
      if (!isValidPassword) {
        message.error('Contraseña incorrecta');
        return;
      }

      // Prepare user data for login
      const userData = {
        id: user.id,
        nombre: user.nombre,
        email: user.email,
        role: user.role,
        ciudadId: user.ciudadId,
        ciudad: user.Ciudad ? user.Ciudad.nombre : '',
        salarioBase: user.salarioBase
      };

      onLogin(userData);
      message.success(`Bienvenido, ${user.nombre}`);

    } catch (error) {
      console.error('Login error:', error);
      message.error('Error al iniciar sesión: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
        title={
          <Title level={3} style={{ textAlign: 'center', margin: 0 }}>
            Simulador de Comisiones RCN
          </Title>
        }
      >
        <Form
          form={form}
          name="login"
          layout="vertical"
          onFinish={handleLogin}
          size="large"
        >
          <Form.Item
            name="email"
            label="Correo Electrónico"
            rules={[
              { required: true, message: 'Por favor ingrese su correo' },
              { type: 'email', message: 'Ingrese un correo válido' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="admin@rcn.com" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Contraseña"
            rules={[
              { required: true, message: 'Por favor ingrese su contraseña' }
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Contraseña" 
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              style={{ width: '100%' }}
            >
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ textAlign: 'center', marginTop: '16px', color: '#666' }}>
          <p>Usuario administrativo: admin@rcn.com</p>
          <p>Contraseña: admin123</p>
        </div>
      </Card>
    </div>
  );
};

export default Login;